import React, { Component } from 'react'; //import React Component
import {Quiz} from './QuizPage';
import {SignUpForm} from './Authentication'
import {Flower} from './Flower'
import Cards from './Card';
import './css/style.css'; //import css file!
import Footer from './Footer.js'
import logo from './img/logo.png';
import Tom from './img/tom.png'; 
import Timmy from './img/timmy.png'; 
import Tommy from './img/tommy.png'; 
import {Redirect, NavLink} from 'react-router-dom';
import {Route} from 'react-router-dom';
import {Switch} from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

class App extends Component {
  constructor(props){
    super(props);

    this.state = {
      displayedCharacter: '',
      user: null
    }
  }

// This function was based off the code from: https://stackoverflow.com/questions/57789709/firebase-auth-currentuser-uid-cant-find-uid-of-undefined
componentDidMount = () => {
    firebase.auth().onAuthStateChanged((user)=>{
        if (user) {
            this.setState({ user });
            console.log(user);
            var uid=user.uid;
            let characterRef = firebase.database().ref('users').child(uid).child('characterImage') //here's how we get access to the message key
            characterRef.on('value', (snapshot) => {
              let value = snapshot.val();
              this.setState({displayedCharacter: value});
            });
        } else {
            this.setState({ user: null});
            this.setState({ displayedCharacter: "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fupload.wikimedia.org%2Fwikipedia%2Fen%2Fthumb%2F7%2F72%2FTom_Nook.png%2F220px-Tom_Nook.png&f=1&nofb=1"});
        }
        
    });
  }

  render() {
    return (

      <main>
 			  <header>
 				  <div className="flex-container">
 					  <a href="index.html"><img src={logo} alt="Animal Crossing Passport Quiz Logo" className="logo"></img></a>
             <h1 className="website-title">Animal Crossing <br></br> Passport Quiz</h1>
             <img src={Tom} alt="Profile Tom Nook" className="profilepicture"></img>
 				  </div>
 			  </header>
      
        <div className="mainpage">
          <AboutNav />
          <br></br>
          <Switch>
            <Route exact path='/' render={() => (
                  <Tanukis displayedCharacter={this.state.displayedCharacter} />
            )}></Route>               
            <Route exact path="/personality-quiz" component={Quiz}/>
            <Route exact path="/villagers-cards" component={Cards}/>
            <Route exact path="/authentication" component={SignUpForm}/>
            <Route exact path="/flower" component={Flower}/>

            <Redirect to='/' />
            
            
          </Switch>
        </div>

        <Footer />
      </main>
    );
  }
}

// Edited by: Israel, 06.04.20
class AboutNav extends Component {
  render() {

    var pointers = document.getElementsByClassName("navPointer");
    for(var i = 0; i < pointers.length; i++) {
      pointers[i].hidden = true;
    }

    var inputs = document.getElementsByClassName("navOption");
    for(var j = 0; j < inputs.length; j++) {
      let index = j;
      inputs[j].addEventListener("mouseenter", function() {
        document.getElementById("p" + index).hidden = false;
      });
      inputs[j].addEventListener("mouseleave", function() {
        document.getElementById("p" + index).hidden = true;
      });
    }
    
    return (
      <div className="navBackground">
        <div className="navBubble">

          <div className="navRow">
          <div id="p0" className="navPointer">&nbsp;</div>
          <NavLink className="navOption" exact to="/authentication" activeClassName="activeLink" style={{ textDecoration: 'none' }} >
            <p className="navText">Authentication</p>
          </NavLink>
          </div>

          <div className="navRow">
          <div id="p1" className="navPointer">&nbsp;</div>
            <NavLink className="navOption" exact to="/" activeClassName="activeLink" style={{ textDecoration: 'none' }} >
              <p className="navText">Home</p>
            </NavLink>
          </div>

          <div className="navRow">
          <div id="p2" className="navPointer">&nbsp;</div>
            <NavLink className="navOption" exact to="/personality-quiz" activeClassName="activeLink" style={{ textDecoration: 'none' }} >
              <p className="navText">Personality Quiz</p>
            </NavLink>
          </div>

          <div className="navRow">
          <div id="p3" className="navPointer">&nbsp;</div>
            <NavLink className="navOption" exact to="/villagers-cards" activeClassName="activeLink" style={{ textDecoration: 'none' }} >
                <p className="navText">Villager Directory</p>
            </NavLink>
          </div>

          <div className="navRow">
          <div id="p4" className="navPointer">&nbsp;</div>
            <NavLink className="navOption" exact to="/flower" activeClassName="activeLink" style={{ textDecoration: 'none' }} >
                <p className="navText">Breed Flowers</p>
            </NavLink>
          </div>
        </div>
      </div>
    );
  }  
}

class Tanukis extends Component {
  render() {
    let displayedCharacter = this.props.displayedCharacter

    return (
      <div>
        <div className="tanukis-flex-container">
          <img className="tommy" src={Tommy}alt="tommy on an inner tube"></img>
          <img className="timmy" src={Timmy} alt="timmy on an inner tube"></img>
          <img className="tom" src={Tom} alt="tom nook on an inner tube"></img>
        </div>

        <br></br>

        <div className="main-page-image-flex-container">
          <div className="homeResContainer">
            <div className="bubble-dots">
              <p className="saved-quiz-results-title">Most Recent Quiz Results:</p>
            </div>
            <br></br>
            <div className="bubble-dots">
              <img className="homepage-character" src={displayedCharacter} alt="tom nook"></img>
            </div>
          </div>
        </div>
    </div>
    );
  }  
}


export default App;
